/* eslint-disable @next/next/no-img-element */
import http from 'utilities/http';
import { getCookie } from "framework/libs/cookie";
import { TOKEN_CONGDONG } from "framework/store/constants";
import { SLUG_LIST } from "utilities/constants";
import { useCart } from "framework/store";
import { useRouter } from "next/router";
import ProductPage from '../[...id]';
import { useEffect } from 'react';
import { isEmpty } from 'lodash';
import { isStaging } from 'utilities/api';

const contentType = (slug) => {
    let contentType = 'article';
    switch (slug) {
    case 'kho-anh':
        contentType = 'album';
        break;
    case 'album':
        contentType = 'album';
        break;
    case 'thao-luan':
        contentType = 'thread';
        break;
    case 'chuyen-gia':
        contentType = 'professional';
        break;
    }
    return contentType;
};

const addPreview = `?show_preview=1`;

export default function Article({ path, article: articleSSG }) {
    const [stateStore, actions] = useCart();
    const router = useRouter();
    const listAdmin = [
        'linh.trankhanh@happynest.vn',
        'linh.nguyenkhanh@happynest.vn',
        'thao.buiphuong@happynest.vn',
        'minh.caotuyet@happynest.vn',
        'trang.buiminh@happynest.vn',
        'info@happynest.vn',
        'admin@happynest.vn',
        'nghiepnv@gmail.com',
        'ntphuongtrang.happynest@gmail.com',
        'hgngoclinh2009@gmail.com',
        'huongquynhnguyen9717@gmail.com',
        'lk4111273@gmail.com',
        'lacrang229@gmail.com',
        'nguyentranhanh2005@gmail.com',
        'lt054196@gmail.com'
    ];
    const isOwn = isStaging || listAdmin.some(x => x === stateStore.profileCommunity?.email) || stateStore.profileCommunity?.id === articleSSG.user.id;

    useEffect(() => {
        if (isEmpty(getCookie(TOKEN_CONGDONG))) {
            router.push('404.html');
        }
        if (isEmpty(stateStore.profileCommunity)) {
            return;
        }
        if (!isOwn) router.push('404.html');
    }, [router, stateStore.profileCommunity]);

    return isOwn ? <ProductPage path={path} article={articleSSG} addPreview={addPreview} /> : <></>;
};

export const getServerSideProps = async ({ params }) => {
    if (!isStaging) {
        const res = await http(`community/${contentType(params.id[0])}/${params.id[1]}/preview`, {}, {}, 'v2');
        if (res.success == false) {
            return {
                notFound: true,
            };
        };

        return {
            props: {
                article: res.data || {},
                path: params.id,
            },
        };
    } else {
        return {
            props: {
                article: {},
                path: params.id,
            },
        };
    }

    // const res = await http(`community/${contentType(params.id[0])}/${params.id[1]}/preview`, {}, {}, 'v2');
    // if (res.success == false) {
    //     return {
    //         notFound: true,
    //     };
    // };

    // return {
    //     props: {
    //         article: res.data || {},
    //         path: params.id,
    //     },
    // };
};
